import { ZonaHistorico } from './zona-historico';
import { ZonaHistoricoBarrio } from './zona-historico-barrio';

export class ZonaHistoricoIntervencion {
  fecha: Date;
  usuario: string;
  idUsuario: string;
  acciones: ZonaHistorico[] = [];
  barrios: ZonaHistoricoBarrio[] = [];
}
